export const getBoundingClientRect = element => { 
  const {top, right, bottom, left, width, height, x, y} = element.getBoundingClientRect()
  return {top, right, bottom, left, width, height, x, y} 
}

//function to find country from url
export const getEnvironment = () => {
  const href = window.location.href;

  if (href.includes("staging")) return "staging";
  if (href.includes("localhost")) return "development";
  return "production";
};

//for cookie yes banner
export const getCookieyesId = (environment) => {
  let cookieyesId;

  if (environment === "production") {
    cookieyesId = "fbbfc924951cf4fd3fd6c079";
  } else if (environment === "staging") {
    cookieyesId = "8c16dec01ef6c1a6ee1bc0e9";
  }

  return cookieyesId;
};

//capatlise uppercase txt 
export const capitalize = (str) => str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
